module.exports = __webpack_public_path__ + "img/icon-support.01e7ff3e.png";